import React, { FC } from 'react'
import { ListItemButton, ListItemButtonProps } from '@mui/material'

const EvtListItemButton: FC<ListItemButtonProps> = ({ children, ...props }) => {
    return <ListItemButton {...props}>{children}</ListItemButton>
}

export default EvtListItemButton
